export const createEntity = (entity) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make some async call
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const profileuid = getState().firebase.auth.uid;
        firestore.collection('entities').add({
            ...entity,
            entitytype: 51,
            entitybyuser: profileuid,
            createdbyuser: profileuid,
            createdbyuserfullname: profile.firstname + " " + profile.lastname,
            createddate: new Date()
        }).then( () => {
            dispatch({ type: 'CREATE_ENTITY', entity: entity})
        }).catch( (err) => {
            dispatch({ type: 'CREATE_ENTITY_ERROR', err})
        })
    }
};

export const updateEntity = (entity, entityid) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make some async call
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const profileuid = getState().firebase.auth.uid;
        firestore.collection('entities').doc(entityid).update({
            ...entity,
            entitytype: 51,
            entitybyuser: profileuid,
            updatedbyuser: profileuid,
            updatedbyuserfullname: profile.firstname + " " + profile.lastname,
            updateddate: new Date()
        }).then( () => {
            dispatch({ type: 'UPDATE_ENTITY', entity: entity})
        }).catch( (err) => {
            dispatch({ type: 'UPDATE_ENTITY_ERROR', err})
        })
    }
};

export const deleteEntity = (entityid) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make some async call
        const firestore = getFirestore();
        firestore.collection('entities').doc(entityid).delete().then( () => {
            dispatch({ type: 'DELETE_ENTITY'})
        }).catch( (err) => {
            dispatch({ type: 'DELETE_ENTITY_ERROR', err})
        })
    }
};

export const createWellnessEntity = (entity) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        // make some async call
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const profileuid = getState().firebase.auth.uid;
        firestore.collection('wellness').add({
            ...entity,
            entitytype: 511,
            entitybyuser: profileuid,
            createdbyuser: profileuid,
            createdbyuserfullname: profile.firstname + " " + profile.lastname,
            createddate: new Date()
        }).then( () => {
            dispatch({ type: 'CREATE_WELLNESSREPORT', entity: entity})
        }).catch( (err) => {
            dispatch({ type: 'CREATE_WELLNESSREPORT_ERROR', err})
        })
    }
};
